import { Fragment, memo } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'

import { renderContractCell } from './EntityTabContractTableRow.utils'

import * as styles from './EntityTabContractTableRow.module.css'

function EntityTabContractTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  getArrowNavigationItemProps,
  getOnClickProps,
  hideCheckbox,
  index,
  isResizing,
  isSelected,
  isShort,
  item,
  qaName,
  resizingColumn,
  scrollRef,
  showCellBorder,
  statuses,
  ...restProps
}) {
  const { t } = useTranslation()

  const {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps }, { getOnClickProps })

  const rowClass = useTableRowModClassName({
    className: styles.EntityTabContractTableRow,
    isSelected,
  })

  const qaProps = getTableRowQaProps(qaName)

  return (
    <div
      {...qaProps}
      {...getArrowNavigationItemProps?.(index)}
      className={rowClass}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={hideCheckbox}
          selected={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderContractCell({
            durationUnit: t('ContractTable.DurationMonthsKey'),
            isActive: column.name === resizingColumn,
            isResizing,
            isShort,
            item,
            name: column.name,
            scrollRef,
            showCellBorder,
            statuses,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item)?.length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default memo(EntityTabContractTableRow)
